export default "__VITE_ASSET__Brhw7Wpv__"